// Legal content — bilingual (CA / ES)
// Company: Xpro Fitness S.L. · CIF B27555770 · C/ Sils 17, 17411 Vidreres, Girona
// Registro Mercantil de Girona, Sección 8, Hoja GI-78944, Inscripción 1 (Tomo 0, Folio 0)

export const COMPANY = {
  name: "Xpro Fitness S.L.",
  cif: "B27555770",
  address: "C/ Sils, 17 · 17411 Vidreres, Girona",
  email: "hola@xprofitness.es",
  registry:
    "Registro Mercantil de Girona, Sección 8, Hoja GI-78944, Inscripción 1 (Tomo 0, Folio 0)",
  domain: "xprofitness.es",
  updated: "2026-06-15",
};

export const LEGAL_INDEX = [
  { slug: "aviso-legal", ca: "Avís legal", es: "Aviso legal" },
  { slug: "privacidad", ca: "Privacitat", es: "Privacidad" },
  { slug: "cookies", ca: "Cookies", es: "Cookies" },
  { slug: "condiciones", ca: "Condicions", es: "Condiciones" },
];

const p = (...paragraphs) => paragraphs;

export const LEGAL_PAGES = {
  //
  // ───────── AVISO LEGAL ─────────
  //
  "aviso-legal": {
    es: {
      title: "Aviso legal",
      overline: "Información LSSI-CE",
      intro:
        "En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los siguientes datos identificativos del titular del sitio web.",
      sections: [
        {
          title: "Titular del sitio web",
          body: p(
            `Denominación social: ${COMPANY.name}`,
            `NIF/CIF: ${COMPANY.cif}`,
            `Domicilio social: ${COMPANY.address}`,
            `Correo electrónico: ${COMPANY.email}`,
            `Inscripción registral: ${COMPANY.registry}`,
            `Dominio: https://${COMPANY.domain}`
          ),
        },
        {
          title: "Objeto del sitio web",
          body: p(
            "El sitio tiene por objeto ofrecer información sobre las instalaciones, servicios, tarifas, horarios y demás actividades del centro deportivo XPRO FITNESS ubicado en Vidreres (Girona), así como permitir la reserva de plazas fundadoras y la comunicación con el cliente."
          ),
        },
        {
          title: "Condiciones de uso",
          body: p(
            "El acceso y uso del sitio atribuye la condición de Usuario e implica la aceptación de las presentes condiciones. El Usuario se compromete a utilizar el sitio conforme a la ley, a estas condiciones, a la moral y al orden público, absteniéndose de utilizarlo con fines ilícitos o que puedan dañar la imagen, los intereses o los derechos de XPRO FITNESS o de terceros.",
            "El titular podrá suspender temporalmente el acceso al sitio, sin previo aviso, por razones técnicas, de seguridad, de mantenimiento o por cualquier otra causa justificada."
          ),
        },
        {
          title: "Propiedad intelectual e industrial",
          body: p(
            "Todos los contenidos del sitio (textos, fotografías, gráficos, logotipos, iconos, imágenes, código fuente, marcas y en general cualquier información) son propiedad de XPRO FITNESS S.L. o de terceros que han autorizado su uso, y están protegidos por la legislación española e internacional en materia de propiedad intelectual e industrial.",
            "Queda prohibida su reproducción, distribución, comunicación pública o transformación, total o parcial, sin autorización expresa y por escrito del titular."
          ),
        },
        {
          title: "Enlaces a terceros",
          body: p(
            "El sitio puede contener enlaces a páginas web de terceros. XPRO FITNESS no asume responsabilidad alguna por el contenido, funcionamiento o disponibilidad de dichos sitios ni por los daños que pudieran derivarse de su uso."
          ),
        },
        {
          title: "Exclusión de responsabilidad",
          body: p(
            "XPRO FITNESS no se hace responsable de los daños o perjuicios que pudieran derivarse de interferencias, omisiones, interrupciones, virus informáticos, averías telefónicas o desconexiones en el funcionamiento operativo del sistema electrónico, motivadas por causas ajenas a la empresa.",
            "Tampoco se responsabiliza de retrasos o bloqueos en el uso del sistema causados por deficiencias o sobrecargas de líneas telefónicas o de Internet."
          ),
        },
        {
          title: "Legislación aplicable y jurisdicción",
          body: p(
            "Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia derivada del uso del sitio, las partes se someten a los Juzgados y Tribunales de la ciudad de Girona, salvo que la ley aplicable imponga otra jurisdicción."
          ),
        },
      ],
    },
    ca: {
      title: "Avís legal",
      overline: "Informació LSSI-CE",
      intro:
        "En compliment de l'article 10 de la Llei 34/2002, d'11 de juliol, de Serveis de la Societat de la Informació i de Comerç Electrònic (LSSI-CE), s'informa de les següents dades identificatives del titular del lloc web.",
      sections: [
        {
          title: "Titular del lloc web",
          body: p(
            `Denominació social: ${COMPANY.name}`,
            `NIF/CIF: ${COMPANY.cif}`,
            `Domicili social: ${COMPANY.address}`,
            `Correu electrònic: ${COMPANY.email}`,
            `Inscripció registral: ${COMPANY.registry}`,
            `Domini: https://${COMPANY.domain}`
          ),
        },
        {
          title: "Objecte del lloc web",
          body: p(
            "El lloc té per objecte oferir informació sobre les instal·lacions, serveis, tarifes, horaris i altres activitats del centre esportiu XPRO FITNESS ubicat a Vidreres (Girona), així com permetre la reserva de places fundadores i la comunicació amb el client."
          ),
        },
        {
          title: "Condicions d'ús",
          body: p(
            "L'accés i ús del lloc atribueix la condició d'Usuari i implica l'acceptació d'aquestes condicions. L'Usuari es compromet a utilitzar el lloc conforme a la llei, a aquestes condicions, a la moral i a l'ordre públic, i s'absté d'utilitzar-lo amb finalitats il·lícites o que puguin danyar la imatge, els interessos o els drets de XPRO FITNESS o de tercers.",
            "El titular podrà suspendre temporalment l'accés al lloc, sense avís previ, per raons tècniques, de seguretat, de manteniment o per qualsevol altra causa justificada."
          ),
        },
        {
          title: "Propietat intel·lectual i industrial",
          body: p(
            "Tots els continguts del lloc (textos, fotografies, gràfics, logotips, icones, imatges, codi font, marques i en general qualsevol informació) són propietat de XPRO FITNESS S.L. o de tercers que n'han autoritzat l'ús, i estan protegits per la legislació espanyola i internacional en matèria de propietat intel·lectual i industrial.",
            "Queda prohibida la seva reproducció, distribució, comunicació pública o transformació, total o parcial, sense autorització expressa i per escrit del titular."
          ),
        },
        {
          title: "Enllaços a tercers",
          body: p(
            "El lloc pot contenir enllaços a pàgines web de tercers. XPRO FITNESS no assumeix cap responsabilitat pel contingut, funcionament o disponibilitat d'aquests llocs ni pels danys que puguin derivar-se'n."
          ),
        },
        {
          title: "Exclusió de responsabilitat",
          body: p(
            "XPRO FITNESS no es fa responsable dels danys o perjudicis que puguin derivar-se d'interferències, omissions, interrupcions, virus informàtics, avaries telefòniques o desconnexions en el funcionament operatiu del sistema electrònic, motivats per causes alienes a l'empresa.",
            "Tampoc es responsabilitza de retards o bloquejos en l'ús del sistema causats per deficiències o sobrecàrregues de línies telefòniques o d'Internet."
          ),
        },
        {
          title: "Legislació aplicable i jurisdicció",
          body: p(
            "Aquestes condicions es regeixen per la legislació espanyola. Per a la resolució de qualsevol controvèrsia derivada de l'ús del lloc, les parts se sotmeten als Jutjats i Tribunals de la ciutat de Girona, llevat que la llei aplicable imposi una altra jurisdicció."
          ),
        },
      ],
    },
  },

  //
  // ───────── PRIVACIDAD ─────────
  //
  privacidad: {
    es: {
      title: "Política de privacidad",
      overline: "RGPD · LOPDGDD",
      intro:
        "En cumplimiento del Reglamento (UE) 2016/679 (RGPD) y de la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), le informamos sobre el tratamiento que XPRO FITNESS realiza de sus datos personales.",
      sections: [
        {
          title: "Responsable del tratamiento",
          body: p(
            `Responsable: ${COMPANY.name} (NIF ${COMPANY.cif})`,
            `Domicilio: ${COMPANY.address}`,
            `Contacto para asuntos de privacidad: ${COMPANY.email}`
          ),
        },
        {
          title: "Datos que recogemos",
          body: p(
            "A través del formulario de reserva de plaza fundadora tratamos los siguientes datos: nombre, apellidos, correo electrónico, teléfono, DNI/NIE, fecha de nacimiento y los comentarios que el interesado facilite voluntariamente.",
            "Además, cuando se contrate la cuota de socio, podremos tratar datos económicos (cuenta bancaria o tarjeta) necesarios para la gestión de los cobros mensuales.",
            "El sitio web no utiliza cookies analíticas ni publicitarias; únicamente cookies técnicas propias imprescindibles para su funcionamiento (ver Política de Cookies)."
          ),
        },
        {
          title: "Finalidades del tratamiento",
          body: p(
            "1. Gestionar la reserva de plaza fundadora y contactar con el interesado para formalizar el alta.",
            "2. Prestar los servicios contratados (acceso a las instalaciones, entrenamiento personal, clases, nutrición, rutinas).",
            "3. Gestionar la facturación y los cobros de las cuotas.",
            "4. Cumplir con las obligaciones legales, fiscales y contables aplicables.",
            "5. Enviar comunicaciones informativas relativas a la relación contractual (cambios de horarios, cierres puntuales, actualizaciones de servicio).",
            "No se realizan tratamientos con fines publicitarios ni se ceden datos con esa finalidad."
          ),
        },
        {
          title: "Base legal",
          body: p(
            "Consentimiento del interesado al rellenar y enviar el formulario de reserva (art. 6.1.a RGPD).",
            "Ejecución de un contrato o de medidas precontractuales solicitadas por el interesado (art. 6.1.b RGPD) para las gestiones necesarias antes y durante la relación como socio.",
            "Cumplimiento de una obligación legal aplicable al responsable (art. 6.1.c RGPD) en materia contable, fiscal y de conservación de justificantes."
          ),
        },
        {
          title: "Plazo de conservación",
          body: p(
            "Los datos de la reserva de plaza fundadora se conservarán hasta la efectiva alta como socio o, en su defecto, hasta un máximo de 24 meses desde la solicitud, salvo revocación previa del consentimiento.",
            "Los datos de socios activos se conservarán durante toda la vigencia del contrato y, tras la baja, durante los plazos legales exigidos (hasta 6 años para obligaciones mercantiles y fiscales)."
          ),
        },
        {
          title: "Destinatarios",
          body: p(
            "Los datos no se ceden a terceros salvo obligación legal.",
            "Podrán acceder a ellos, exclusivamente en calidad de encargados del tratamiento, los proveedores necesarios para prestar el servicio (por ejemplo: proveedor de alojamiento web, plataforma de cobros, gestoría contable), con los que se firman los correspondientes contratos de encargo.",
            "No se realizan transferencias internacionales de datos fuera del Espacio Económico Europeo salvo que el proveedor cuente con las garantías adecuadas (cláusulas contractuales tipo aprobadas por la Comisión Europea)."
          ),
        },
        {
          title: "Derechos del interesado",
          body: p(
            "Puede ejercer en cualquier momento los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, portabilidad y a no ser objeto de decisiones automatizadas.",
            `Para ello, envíe una solicitud a ${COMPANY.email} adjuntando copia de un documento identificativo.`,
            "Si considera que sus derechos no han sido debidamente atendidos, puede presentar reclamación ante la Agencia Española de Protección de Datos (www.aepd.es)."
          ),
        },
        {
          title: "Medidas de seguridad",
          body: p(
            "XPRO FITNESS ha adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad, confidencialidad e integridad de los datos personales tratados, evitando su alteración, pérdida, tratamiento o acceso no autorizado, de acuerdo con el estado de la tecnología."
          ),
        },
      ],
    },
    ca: {
      title: "Política de privacitat",
      overline: "RGPD · LOPDGDD",
      intro:
        "En compliment del Reglament (UE) 2016/679 (RGPD) i de la Llei Orgànica 3/2018 de Protecció de Dades Personals i garantia dels drets digitals (LOPDGDD), us informem sobre el tractament que XPRO FITNESS fa de les vostres dades personals.",
      sections: [
        {
          title: "Responsable del tractament",
          body: p(
            `Responsable: ${COMPANY.name} (NIF ${COMPANY.cif})`,
            `Domicili: ${COMPANY.address}`,
            `Contacte per a assumptes de privacitat: ${COMPANY.email}`
          ),
        },
        {
          title: "Dades que recollim",
          body: p(
            "A través del formulari de reserva de plaça fundadora tractem les següents dades: nom, cognoms, correu electrònic, telèfon, DNI/NIE, data de naixement i els comentaris que l'interessat faciliti voluntàriament.",
            "A més, quan es contracti la quota de soci, podrem tractar dades econòmiques (compte bancari o targeta) necessàries per a la gestió dels cobraments mensuals.",
            "El lloc web no utilitza cookies analítiques ni publicitàries; únicament cookies tècniques pròpies imprescindibles per al seu funcionament (vegeu la Política de Cookies)."
          ),
        },
        {
          title: "Finalitats del tractament",
          body: p(
            "1. Gestionar la reserva de plaça fundadora i contactar amb l'interessat per formalitzar l'alta.",
            "2. Prestar els serveis contractats (accés a les instal·lacions, entrenament personal, classes, nutrició, rutines).",
            "3. Gestionar la facturació i els cobraments de les quotes.",
            "4. Complir amb les obligacions legals, fiscals i comptables aplicables.",
            "5. Enviar comunicacions informatives relatives a la relació contractual (canvis d'horaris, tancaments puntuals, actualitzacions de servei).",
            "No es realitzen tractaments amb finalitats publicitàries ni es cedeixen dades amb aquesta finalitat."
          ),
        },
        {
          title: "Base legal",
          body: p(
            "Consentiment de l'interessat en omplir i enviar el formulari de reserva (art. 6.1.a RGPD).",
            "Execució d'un contracte o de mesures precontractuals sol·licitades per l'interessat (art. 6.1.b RGPD) per a les gestions necessàries abans i durant la relació com a soci.",
            "Compliment d'una obligació legal aplicable al responsable (art. 6.1.c RGPD) en matèria comptable, fiscal i de conservació de justificants."
          ),
        },
        {
          title: "Termini de conservació",
          body: p(
            "Les dades de la reserva de plaça fundadora es conservaran fins a l'efectiva alta com a soci o, en el seu defecte, fins a un màxim de 24 mesos des de la sol·licitud, tret de revocació prèvia del consentiment.",
            "Les dades de socis actius es conservaran durant tota la vigència del contracte i, després de la baixa, durant els terminis legals exigits (fins a 6 anys per a obligacions mercantils i fiscals)."
          ),
        },
        {
          title: "Destinataris",
          body: p(
            "Les dades no es cedeixen a tercers, tret d'obligació legal.",
            "Podran accedir-hi, exclusivament en qualitat d'encarregats del tractament, els proveïdors necessaris per prestar el servei (per exemple: proveïdor d'allotjament web, plataforma de cobraments, gestoria comptable), amb els quals se signen els contractes d'encàrrec corresponents.",
            "No es realitzen transferències internacionals de dades fora de l'Espai Econòmic Europeu, tret que el proveïdor compti amb les garanties adequades (clàusules contractuals tipus aprovades per la Comissió Europea)."
          ),
        },
        {
          title: "Drets de l'interessat",
          body: p(
            "Podeu exercir en qualsevol moment els drets d'accés, rectificació, supressió, oposició, limitació del tractament, portabilitat i a no ser objecte de decisions automatitzades.",
            `Per fer-ho, envieu una sol·licitud a ${COMPANY.email} adjuntant còpia d'un document identificatiu.`,
            "Si considereu que els vostres drets no han estat degudament atesos, podeu presentar reclamació davant l'Agència Espanyola de Protecció de Dades (www.aepd.es)."
          ),
        },
        {
          title: "Mesures de seguretat",
          body: p(
            "XPRO FITNESS ha adoptat les mesures tècniques i organitzatives necessàries per garantir la seguretat, confidencialitat i integritat de les dades personals tractades, evitant-ne l'alteració, pèrdua, tractament o accés no autoritzat, d'acord amb l'estat de la tecnologia."
          ),
        },
      ],
    },
  },

  //
  // ───────── COOKIES ─────────
  //
  cookies: {
    es: {
      title: "Política de cookies",
      overline: "Uso de cookies técnicas",
      intro:
        "Esta política describe el uso de cookies y tecnologías similares en el sitio web xprofitness.es. Actualmente utilizamos exclusivamente cookies técnicas propias, que son estrictamente necesarias para el funcionamiento del sitio y no requieren consentimiento previo del usuario.",
      sections: [
        {
          title: "¿Qué son las cookies?",
          body: p(
            "Las cookies son pequeños archivos de texto que un sitio web instala en el dispositivo del usuario cuando este lo visita. Sirven para almacenar información sobre la navegación o las preferencias, y pueden ser de sesión (se eliminan al cerrar el navegador) o persistentes (permanecen durante un tiempo determinado)."
          ),
        },
        {
          title: "Cookies que utilizamos",
          body: p(
            "En este sitio únicamente se utilizan cookies técnicas propias, imprescindibles para su correcto funcionamiento:",
            "· xpro_lang · Almacena el idioma seleccionado (catalán o español) para mantenerlo entre visitas. Persistente (localStorage).",
            "· xpro_banner_closed · Recuerda si el usuario ha cerrado el banner superior de próxima apertura. De sesión (sessionStorage).",
            "· xpro_admin_token · Únicamente presente en el panel de administración (/admin) tras iniciar sesión. Contiene el token de autenticación cifrado. Persistente (localStorage).",
            "El sitio NO utiliza cookies analíticas, de rendimiento ni publicitarias (Google Analytics, Meta Pixel, etc.). No se comparten datos con terceros con fines de marketing."
          ),
        },
        {
          title: "Consentimiento",
          body: p(
            "Dado que solo utilizamos cookies técnicas estrictamente necesarias, no se solicita consentimiento previo, tal y como establece el considerando 30 del RGPD y las directrices de la AEPD sobre uso de cookies (noviembre 2023). Si en el futuro se incorporan cookies no exentas de consentimiento, se implementará un banner de consentimiento con opciones de configuración granular."
          ),
        },
        {
          title: "Cómo desactivar cookies",
          body: p(
            "El usuario puede en cualquier momento eliminar o desactivar las cookies desde la configuración de su navegador. A continuación se enlazan las guías oficiales:",
            "· Google Chrome — support.google.com/chrome",
            "· Mozilla Firefox — support.mozilla.org",
            "· Safari — support.apple.com",
            "· Microsoft Edge — support.microsoft.com",
            "La desactivación de las cookies técnicas puede afectar al correcto funcionamiento del sitio (por ejemplo, no se recordará el idioma seleccionado)."
          ),
        },
        {
          title: "Modificaciones",
          body: p(
            "XPRO FITNESS podrá modificar esta política para adaptarla a nuevos requerimientos legales o cambios en el funcionamiento del sitio. Se recomienda revisar periódicamente esta página."
          ),
        },
      ],
    },
    ca: {
      title: "Política de cookies",
      overline: "Ús de cookies tècniques",
      intro:
        "Aquesta política descriu l'ús de cookies i tecnologies similars al lloc web xprofitness.es. Actualment utilitzem exclusivament cookies tècniques pròpies, que són estrictament necessàries per al funcionament del lloc i no requereixen consentiment previ de l'usuari.",
      sections: [
        {
          title: "Què són les cookies?",
          body: p(
            "Les cookies són petits arxius de text que un lloc web instal·la al dispositiu de l'usuari quan aquest el visita. Serveixen per emmagatzemar informació sobre la navegació o les preferències, i poden ser de sessió (s'eliminen en tancar el navegador) o persistents (romanen durant un temps determinat)."
          ),
        },
        {
          title: "Cookies que utilitzem",
          body: p(
            "En aquest lloc únicament s'utilitzen cookies tècniques pròpies, imprescindibles per al seu correcte funcionament:",
            "· xpro_lang · Emmagatzema l'idioma seleccionat (català o espanyol) per mantenir-lo entre visites. Persistent (localStorage).",
            "· xpro_banner_closed · Recorda si l'usuari ha tancat el bàner superior de pròxima obertura. De sessió (sessionStorage).",
            "· xpro_admin_token · Únicament present al panell d'administració (/admin) després d'iniciar sessió. Conté el testimoni d'autenticació xifrat. Persistent (localStorage).",
            "El lloc NO utilitza cookies analítiques, de rendiment ni publicitàries (Google Analytics, Meta Pixel, etc.). No es comparteixen dades amb tercers amb finalitats de màrqueting."
          ),
        },
        {
          title: "Consentiment",
          body: p(
            "Atès que només utilitzem cookies tècniques estrictament necessàries, no se sol·licita consentiment previ, tal com estableix el considerand 30 del RGPD i les directrius de l'AEPD sobre ús de cookies (novembre 2023). Si en el futur s'incorporen cookies no exemptes de consentiment, s'implementarà un bàner de consentiment amb opcions de configuració granular."
          ),
        },
        {
          title: "Com desactivar cookies",
          body: p(
            "L'usuari pot en qualsevol moment eliminar o desactivar les cookies des de la configuració del seu navegador. A continuació s'enllacen les guies oficials:",
            "· Google Chrome — support.google.com/chrome",
            "· Mozilla Firefox — support.mozilla.org",
            "· Safari — support.apple.com",
            "· Microsoft Edge — support.microsoft.com",
            "La desactivació de les cookies tècniques pot afectar el correcte funcionament del lloc (per exemple, no es recordarà l'idioma seleccionat)."
          ),
        },
        {
          title: "Modificacions",
          body: p(
            "XPRO FITNESS podrà modificar aquesta política per adaptar-la a nous requeriments legals o canvis en el funcionament del lloc. Es recomana revisar periòdicament aquesta pàgina."
          ),
        },
      ],
    },
  },

  //
  // ───────── CONDICIONES ─────────
  //
  condiciones: {
    es: {
      title: "Términos y condiciones",
      overline: "Condiciones de contratación",
      intro:
        "Las presentes condiciones regulan la reserva de plaza fundadora y, cuando corresponda, la contratación de la cuota de socio de XPRO FITNESS. La utilización de estos servicios implica la aceptación plena de las mismas.",
      sections: [
        {
          title: "Objeto",
          body: p(
            "Estas condiciones regulan la relación entre XPRO FITNESS S.L. y el Usuario respecto de: (i) la reserva de plaza fundadora a través del sitio web, y (ii) la posterior contratación de la cuota de socio y el uso de las instalaciones del centro deportivo en Vidreres."
          ),
        },
        {
          title: "Aceptación",
          body: p(
            "El envío del formulario de reserva de plaza fundadora implica la aceptación expresa e inequívoca de estas condiciones y de la Política de Privacidad. Antes de enviar el formulario, el Usuario debe marcar la casilla correspondiente confirmando dicha aceptación."
          ),
        },
        {
          title: "Reserva de plaza fundadora",
          body: p(
            "La reserva de plaza fundadora es un servicio previo a la apertura del centro que garantiza al Usuario, durante 24 meses desde el alta como socio, un precio especial reducido respecto a la cuota estándar.",
            "La reserva NO conlleva pago alguno en el momento del envío del formulario. Es una manifestación de interés no vinculante para el Usuario y sujeta a disponibilidad de plazas (100 plazas en el Pack 1 y 50 plazas adicionales en el Pack 2). Una vez agotadas, el sitio dejará de admitir nuevas reservas.",
            "XPRO FITNESS se pondrá en contacto con el Usuario antes de la apertura para formalizar el alta y proceder al primer cobro."
          ),
        },
        {
          title: "Contratación de la cuota",
          body: p(
            "La formalización del alta como socio se realizará mediante contrato específico donde constarán todos los detalles del servicio, la modalidad de pago y las condiciones particulares.",
            "El pago se realizará mediante domiciliación bancaria (SEPA) o tarjeta bancaria, con cargo mensual anticipado."
          ),
        },
        {
          title: "Precios",
          body: p(
            "· Cuota estándar: 49,90€/mes.",
            "· Pack 1 fundador (primeras 100 plazas): 44,90€/mes durante 24 meses. Matrícula gratuita (valorada en 29€). Incluye 1 entrenamiento personal gratuito al iniciar.",
            "· Pack 2 fundador (siguientes 50 plazas): 46,90€/mes durante 24 meses. Matrícula gratuita.",
            "Transcurridos los 24 meses, la cuota pasará al precio estándar vigente (49,90€/mes o la revisión que en su caso proceda).",
            "Todos los precios se expresan con impuestos incluidos."
          ),
        },
        {
          title: "Duración y baja",
          body: p(
            "La cuota se contrata mensualmente sin permanencia. El Usuario puede darse de baja en cualquier momento comunicándolo con al menos 15 días naturales de antelación respecto al día en que desee que la baja sea efectiva.",
            "La comunicación de baja se realizará por escrito, dirigida al correo electrónico " + COMPANY.email + " o presencialmente en el centro. XPRO FITNESS confirmará por escrito la recepción y la fecha efectiva de baja."
          ),
        },
        {
          title: "Cancelación y devolución",
          body: p(
            "Al no existir permanencia, el Usuario puede cancelar la cuota en cualquier momento respetando el preaviso indicado en el apartado anterior.",
            "Iniciado un período mensual, la cuota correspondiente NO es reembolsable ni prorrateable, salvo que la ley aplicable establezca lo contrario o exista causa imputable a XPRO FITNESS (por ejemplo, cierre no comunicado del centro por causas ajenas a fuerza mayor).",
            "En caso de que XPRO FITNESS no pueda prestar el servicio contratado por causas exclusivamente imputables a la empresa, se devolverá la parte proporcional de la cuota correspondiente al período no disfrutado."
          ),
        },
        {
          title: "Derecho de desistimiento (contratación online)",
          body: p(
            "De conformidad con los arts. 102 y ss. del Real Decreto Legislativo 1/2007, cuando el alta como socio y el primer pago se realicen íntegramente online (a distancia), el Usuario dispone de un plazo de 14 días naturales desde la formalización del contrato para desistir del mismo sin necesidad de justificación y sin penalización.",
            "Para ejercer este derecho, deberá comunicar su decisión mediante una declaración inequívoca dirigida a " + COMPANY.email + ".",
            "Si el Usuario ha comenzado a utilizar los servicios durante el plazo de desistimiento, se le facturará la parte proporcional al servicio efectivamente prestado hasta el momento del ejercicio del derecho, siempre que hubiera aceptado expresamente el inicio del servicio antes del fin del plazo."
          ),
        },
        {
          title: "Uso de las instalaciones",
          body: p(
            "El Usuario se compromete a utilizar las instalaciones y equipamiento del centro con diligencia y respeto, siguiendo las normas internas del gimnasio y las indicaciones del personal.",
            "XPRO FITNESS no se hace responsable de las lesiones o daños que pueda sufrir el Usuario derivados de un uso inadecuado del material o del incumplimiento de dichas normas."
          ),
        },
        {
          title: "Modificación de las condiciones",
          body: p(
            "XPRO FITNESS podrá modificar las presentes condiciones para adaptarlas a cambios normativos o de operativa, comunicándolo con antelación suficiente. En caso de modificaciones sustanciales, el socio podrá dar por finalizada la relación sin coste durante los 30 días siguientes a la notificación."
          ),
        },
        {
          title: "Legislación y jurisdicción",
          body: p(
            "Las presentes condiciones se rigen por la legislación española. Las partes se someten, con renuncia a cualquier otro fuero, a los Juzgados y Tribunales de Girona, salvo cuando por norma imperativa sea aplicable el fuero del consumidor."
          ),
        },
      ],
    },
    ca: {
      title: "Termes i condicions",
      overline: "Condicions de contractació",
      intro:
        "Aquestes condicions regulen la reserva de plaça fundadora i, quan correspongui, la contractació de la quota de soci de XPRO FITNESS. La utilització d'aquests serveis implica l'acceptació plena de les mateixes.",
      sections: [
        {
          title: "Objecte",
          body: p(
            "Aquestes condicions regulen la relació entre XPRO FITNESS S.L. i l'Usuari respecte de: (i) la reserva de plaça fundadora a través del lloc web, i (ii) la posterior contractació de la quota de soci i l'ús de les instal·lacions del centre esportiu a Vidreres."
          ),
        },
        {
          title: "Acceptació",
          body: p(
            "L'enviament del formulari de reserva de plaça fundadora implica l'acceptació expressa i inequívoca d'aquestes condicions i de la Política de Privacitat. Abans d'enviar el formulari, l'Usuari ha de marcar la casella corresponent confirmant aquesta acceptació."
          ),
        },
        {
          title: "Reserva de plaça fundadora",
          body: p(
            "La reserva de plaça fundadora és un servei previ a l'obertura del centre que garanteix a l'Usuari, durant 24 mesos des de l'alta com a soci, un preu especial reduït respecte a la quota estàndard.",
            "La reserva NO comporta cap pagament en el moment de l'enviament del formulari. És una manifestació d'interès no vinculant per a l'Usuari i subjecta a disponibilitat de places (100 places al Pack 1 i 50 places addicionals al Pack 2). Un cop esgotades, el lloc deixarà d'admetre noves reserves.",
            "XPRO FITNESS es posarà en contacte amb l'Usuari abans de l'obertura per formalitzar l'alta i procedir al primer cobrament."
          ),
        },
        {
          title: "Contractació de la quota",
          body: p(
            "La formalització de l'alta com a soci es realitzarà mitjançant contracte específic on constaran tots els detalls del servei, la modalitat de pagament i les condicions particulars.",
            "El pagament es realitzarà mitjançant domiciliació bancària (SEPA) o targeta bancària, amb càrrec mensual anticipat."
          ),
        },
        {
          title: "Preus",
          body: p(
            "· Quota estàndard: 49,90€/mes.",
            "· Pack 1 fundador (primeres 100 places): 44,90€/mes durant 24 mesos. Matrícula gratuïta (valorada en 29€). Inclou 1 entrenament personal gratuït a l'iniciar.",
            "· Pack 2 fundador (següents 50 places): 46,90€/mes durant 24 mesos. Matrícula gratuïta.",
            "Transcorreguts els 24 mesos, la quota passarà al preu estàndard vigent (49,90€/mes o la revisió que en el seu cas procedeixi).",
            "Tots els preus s'expressen amb impostos inclosos."
          ),
        },
        {
          title: "Durada i baixa",
          body: p(
            "La quota es contracta mensualment sense permanència. L'Usuari pot donar-se de baixa en qualsevol moment comunicant-ho amb almenys 15 dies naturals d'antelació respecte al dia en què desitgi que la baixa sigui efectiva.",
            "La comunicació de baixa es realitzarà per escrit, dirigida al correu electrònic " + COMPANY.email + " o presencialment al centre. XPRO FITNESS confirmarà per escrit la recepció i la data efectiva de baixa."
          ),
        },
        {
          title: "Cancel·lació i devolució",
          body: p(
            "En no existir permanència, l'Usuari pot cancel·lar la quota en qualsevol moment respectant el preavís indicat a l'apartat anterior.",
            "Iniciat un període mensual, la quota corresponent NO és reemborsable ni prorratejable, tret que la llei aplicable estableixi el contrari o existeixi causa imputable a XPRO FITNESS (per exemple, tancament no comunicat del centre per causes alienes a força major).",
            "En cas que XPRO FITNESS no pugui prestar el servei contractat per causes exclusivament imputables a l'empresa, es retornarà la part proporcional de la quota corresponent al període no gaudit."
          ),
        },
        {
          title: "Dret de desistiment (contractació online)",
          body: p(
            "De conformitat amb els arts. 102 i següents del Reial Decret Legislatiu 1/2007, quan l'alta com a soci i el primer pagament es realitzin íntegrament online (a distància), l'Usuari disposa d'un termini de 14 dies naturals des de la formalització del contracte per desistir-ne sense necessitat de justificació i sense penalització.",
            "Per exercir aquest dret, haurà de comunicar la seva decisió mitjançant una declaració inequívoca dirigida a " + COMPANY.email + ".",
            "Si l'Usuari ha començat a utilitzar els serveis durant el termini de desistiment, se li facturarà la part proporcional al servei efectivament prestat fins al moment de l'exercici del dret, sempre que hagués acceptat expressament l'inici del servei abans del final del termini."
          ),
        },
        {
          title: "Ús de les instal·lacions",
          body: p(
            "L'Usuari es compromet a utilitzar les instal·lacions i equipament del centre amb diligència i respecte, seguint les normes internes del gimnàs i les indicacions del personal.",
            "XPRO FITNESS no es fa responsable de les lesions o danys que pugui patir l'Usuari derivats d'un ús inadequat del material o de l'incompliment d'aquestes normes."
          ),
        },
        {
          title: "Modificació de les condicions",
          body: p(
            "XPRO FITNESS podrà modificar aquestes condicions per adaptar-les a canvis normatius o d'operativa, comunicant-ho amb antelació suficient. En cas de modificacions substancials, el soci podrà donar per finalitzada la relació sense cost durant els 30 dies següents a la notificació."
          ),
        },
        {
          title: "Legislació i jurisdicció",
          body: p(
            "Aquestes condicions es regeixen per la legislació espanyola. Les parts se sotmeten, amb renúncia a qualsevol altre fur, als Jutjats i Tribunals de Girona, tret que per norma imperativa sigui aplicable el fur del consumidor."
          ),
        },
      ],
    },
  },
};

export function getLegalPage(slug, lang) {
  const page = LEGAL_PAGES[slug];
  if (!page) return null;
  return page[lang] || page.es;
}
